import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import { ButtonSquare } from 'base/components/buttons'
import Direction from '@/enums/direction.enum'
import orgamax from 'ampersand-app'
import SVGIcon from '../svg-icon/svg-icon'
import clsx from 'clsx'

const fontStyles = {
  fontSize: '13px',
  fontWeight: '600',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: '0.25px',
}

const useStyles = makeStyles(theme => ({
  container: {
    position: 'absolute',
    whiteSpace: 'nowrap',
    ...fontStyles,
    zIndex: 25,
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
    paddingRight: '18px',
    color: theme.buttonColor,
    minWidth: '245px',
    height: '37px',
    '& > span': {
      paddingTop: '10px',
      paddingRight: '18px',
      paddingBottom: '10px',
      paddingLeft: '18px',
      alignItems: 'center',
      display: 'flex',
    },
  },
  icon: {
    marginRight: 10,
  },
  button: {
    ...fontStyles,
    fontSize: '12px',
    letterSpacing: '0.23px',
    padding: '0 10px 0 10px',
    height: '22px',
    marginTop: '8px',
    width: 'unset',
    minWidth: '70px',
    borderRadius: '4px',
    background: theme.primary,
  },
  [theme.devices.mobile]: {
    top: {
      width: '100%',
      height: 25,
      transform: 'unset',
      left: 0,
      '& $content': {
        borderRadius: 0,
        height: 25,
      },
    },
    container: {
      position: 'relative',
    },
    button: {
      background: theme.mobileNav.headerButton,
      margin: 0,
      height: 18,
    },
  },
}))

const iconSize = '25px'
export default function TopPanel(props) {
  const {
    children,
    onClick,
    text = 'TopPanel Text',
    buttonLabel = 'button',
    position = Direction.TOP,
    customClass,
    contentClass,
    buttonClass,
    icon,
    hideDemoHeader = false,
  } = props
  const classes = useStyles(props)

  useEffect(() => {
    if (hideDemoHeader && orgamax?.user?.isDemo) {
      const demoHeaders = document.getElementsByClassName('demoHeader')
      if (demoHeaders.length > 0) { demoHeaders[0].style.display = 'none' }

      return () => {
        const demoHeaders = document.getElementsByClassName('demoHeader')
        if (demoHeaders.length > 0) { demoHeaders[0].style.display = '' }
      }
    }
  }, [])

  let buttons = null

  if (children) {
    buttons = children
  } else {
    buttons = onClick
      ? (<ButtonSquare
        label={buttonLabel}
        customClass={clsx(classes.button, buttonClass)}
        onClick={onClick} />)
      : null
  }

  const iconSection = icon ? (<SVGIcon className={classes.icon} svg={icon} width={iconSize} height={iconSize} />) : null

  return (
    <div id='topPanel' className={clsx(classes.container, classes[position], (customClass || ''))}>
      <div className={clsx(classes.content, contentClass)}>
        <span>{iconSection}{text}</span>
        <div>
          {buttons}
        </div>
      </div>
    </div>
  )
}

TopPanel.propTypes = {
  text: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  position: PropTypes.oneOf([Direction.TOP, Direction.BOTTOM]),
  customClass: PropTypes.string,
  hideDemoHeader: PropTypes.bool,
  icon: PropTypes.string,
}
